<app-omni 
[dashboardId]="dashboardId" 
[quotedPriceId]="quotedPriceId">
</app-omni>